// Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved.

// tslint:disable-next-line:class-name
export class API_URL {
    static readonly USER            = '/user';
    static readonly SUBSCRIBE       = '/subscribe';
    static readonly D3E_VERSION_HISTORY = '/api/d3e_versions';
    static readonly SUBSCRIPTIONS   = '/subscriptions';
    static readonly SUBSCRIPTIONS_EXPIRING = '/subscriptions/expiring';
    static readonly SUBSCRIPTIONS_EXTEND = '/subscriptions/extend';
    static readonly SUBSCRIPTION   = '/subscription';
    static readonly SUBSCRIPTION_ALLOCATE   = '/subscription/allocate';
    static readonly LICENSE        = '/license';
    static readonly ACTIVATION_TOKENS = '/activationtokens';
    static readonly DEFAULT_POLICY = '/api/policy/default';
    static readonly ADMIN_SETTINGS   = '/admin-settings';

    // New API
    static readonly API_CONFIG              = '/api/config';
    static readonly API_USER                = '/api/user';
    static readonly API_USERS_REPARENT      = '/api/users/reparent';
    static readonly API_USERS_DEACTIVATE    = '/api/users/deactivate';
    static readonly API_USERS_REACTIVATE    = '/api/users/reactivate';
    static readonly API_USERS_FORCE_EXPIRE  = '/api/users/force-expire-password';
    static readonly API_USERS_SEARCH        = '/api/users/search';
    static readonly API_USER_BY_ID          = '/api/user/by-id';
    static readonly API_USERS               = '/api/users';
    static readonly API_ALL_USERS           = '/api/all-users';
    static readonly API_ORG_TREE           = '/api/v1/org-tree';
    static readonly API_SUPER_USERS         = '/api/superusers';
    static readonly API_USER_SETTINGS       = '/api/user/settings';
    static readonly API_USERS_SUBSCRIPTIONS = '/api/users/subscriptions';
    static readonly API_USERS_SEARCH_SUBS   = '/api/users/subscriptions/search';
    static readonly API_GROUPS              = '/api/groups';
    static readonly API_HEALTH              = '/api/v1/health';
    static readonly API_PARENT_GROUPS       = '/api/v1/parent-groups';
    static readonly API_REPARENT_GROUP      = '/api/v1/group/reparent';
    static readonly API_USER_ROLES          = '/api/user-roles';
    static readonly API_USERS_STATS         = '/users/stats';
    static readonly API_INVITATION_RESET    = '/api/invitation/reset';
    static readonly API_USER_BY_INVITATION  = '/api/invitation';

    static readonly API_V1_GROUPS = '/api/v1/groups';
    static readonly API_V1_GROUPS_NAME_EXISTS = '/api/v1/groups/name-exists';
    static readonly API_V1_GROUP_DEFAULT = '/api/v1/group/default';

    static readonly ORGANIZATIONS           = '/api/organizations';
    static readonly RESERVED_DOMAINS = '/api/v1/reserved-domains';
    static readonly DEACTIVATE_ORGANIZATION = '/api/organizations/deactivate';
    static readonly REACTIVATE_ORGANIZATION = '/api/organizations/reactivate';
    static readonly API_ORGANIZATION = '/api/v1/organization';
    static readonly ACTIVE_DIRECTORY_CONFIG = '/activedirectory/config';
    static readonly ACTIVE_DIRECTORY_LOGIN = '/activedirectory/login';
    static readonly AZURE_MARKET_ACTIVATE = '/azuremarket/activate';

    static readonly API_EVENTS              = '/api/event';
    static readonly API_EVENTS_DOWNLOAD     = '/api/download_event';
    static readonly API_EVENTS_COPIED_DOWNLOAD_URL = '/api/event/copied-download-url';
    static readonly API_SUPPORTED_LANGUAGES = '/api/supported_languages';

    static readonly HOME_CONFIG   = '/home/config';

    static readonly API_POLICIES_D3E  = '/api/policies/d3e';
    static readonly API_POLICY_D3E   = '/api/policy/d3e';
    static readonly API_POLICY_D3E_CLONE = '/api/policy/d3e/clone';
    static readonly API_POLICY_D3E_DELETE = '/api/policy/d3e';
    static readonly API_POLICY_CERTIFICATE = '/api/policy/extract-subject';
    static readonly API_POLICY_CONFIG = '/api/policy/config';
    static readonly API_POLICY_D3E_POST = '/api/policy/d3e';
    static readonly API_POLICY_D3E_PRIORITY = '/api/policy/d3e/priorities';
    static readonly API_FORCE_SYNC   = '/home/force/sync';
    static readonly API_FORCE_POLICY_REST = '/api/policy/d3e';
    static readonly HOME_DEVICES   = '/home/devices';
    static readonly HOME_DEVICE   = '/home/device';
    static readonly HOME_EFFECTIVE_POLICY   = '/home/effective/policy';
    static readonly HOME_ALERTS = '/home/alerts';
    static readonly HOME_ALERT = '/home/alert';
    static readonly HOME_ALERTS_CLEAR = '/home/alerts/clear';
    static readonly API_V1_ENDPOINT = '/api/v1/endpoint';
    static readonly API_PROVISIONING_TEMPLATE = '/api/v1/provisioning_template';
    static readonly API_PROVISION_DRIVES = '/api/v1/provision_drives';
    static readonly API_INSTALL_PBA = '/api/v1/pba-install';
    static readonly API_WIPE_PBA = '/api/v1/pba-wipe';
    static readonly API_DISABLE_PBA = '/api/v1/pba-disable';

    static readonly API_TRACK_ACTION = '/api/action/track';
    static readonly API_TRACK_DOWNLOAD = '/api/action/download';

    static readonly API_POST_THREATS = '/integration/threats';

    static readonly INTEGRATIONS_CONFIG = '/integrations/config';
    static readonly INTEGRATIONS_LIST = '/integrations';
    static readonly INTEGRATIONS_GET = '/integration';
    static readonly INTEGRATIONS_ADMIN = '/integrations/admin';
    static readonly INTEGRATIONS_GET_TOKEN = '/integration_token';
    static readonly INTEGRATIONS_CREATE = '/integration';
    static readonly INTEGRATIONS_UPDATE = '/integration';
    static readonly INTEGRATIONS_DELETE = '/integration';
    static readonly EVENT_LOG_MONITOR_ENABLED = '/event-log-monitor/enabled';
    static readonly EVENT_LOG_MONITORS = '/event-log-monitors';
    static readonly VALIDATE_CYBERARK = '/cyberark_validation';
    static readonly VALIDATE_CARBON_BLACK = '/carbon_black_validation';
    static readonly GET_SOPHOS_TENANTS = '/sophos_tenants';
    static readonly VALIDATE_SENTINEL_ONE = '/sentintel-one-validation';

    static readonly DEVICE_SETS_LIST = '/device-sets';
    static readonly DEVICE_SETS_GET = '/device-sets';
    static readonly DEVICE_SETS_CREATE = '/device-set';
    static readonly DEVICE_SETS_UPDATE = '/device-sets';
    static readonly DEVICE_SETS_DELETE = '/device-sets';

    static readonly ENCRYPTION_DELETE_ALL_KEYS = '/encryptionkeys/deleteall';
    static readonly ENCRYPTION_KEYS = '/api/v1/keys';
    static readonly ENCRYPTION_KEY = '/api/v1/key';
    static readonly ENCRYPTION_HEADER_DECRYPT = '/encryption/header/decrypt';
    static readonly ENCRYPTION_HEADER_SESSIONS = '/encryption/header/sessions';

    static readonly SENSOR_TYPES = '/sensor-types';

    static readonly SECURITY_REQUEST = '/api/v1/security-request';
    static readonly SECURITY_REQUEST_BY_TOKEN = '/api/v1/security-request/vote';
    static readonly SECURITY_REQUEST_TO_APPROVE = '/api/v1/security-request/to-approve';
    static readonly SECURITY_CURRENT_REQUEST = '/api/v1/security-request/current';
    static readonly SECURITY_REQUEST_APPROVERS = '/api/v1/security-request/approvers';
    static readonly SECURITY_REQUEST_APPROVERS_STATUS = '/api/v1/security-request/approvers-status';

    static readonly ENCRYPTION_EVENTS = '/api/v1/encryption-events';

    static readonly GLOBAL_SEARCH = '/api/v1/search';
    static readonly RECENT_SEARCH = '/api/v1/recent';

    static readonly API_V1_LOG = '/api/v1/log';
    static readonly API_V1_DOWNLOADS = '/api/v1/downloads';

}

// tslint:disable-next-line:class-name
export class API_USER_CMD {
    // almost all of these are prefixed with API_URL.API_USER
    static readonly UPDATEPASSWORD      = '/password';
    static readonly RESETPASSWORD       = '/password/reset';
    static readonly VERIFYCODE          = '/password/verify';
    static readonly RENEW_TOKEN         = '/renew';
    static readonly EMAIL_EXISTS        = '/api/v1/user/email/exists';
    static readonly EMAIL_EXISTS_FOR_USER = '/api/v1/user/email/exists/user';
    static readonly USERNAME_EXISTS     = '/username/exists';
    static readonly VERIFY_EMAIL        = '/email/verify';
    static readonly VERIFY_NEW_EMAIL    = '/email/verify/new';
    static readonly CREATE_USER         = '/email';
    static readonly RESEND_VERIFY_EMAIL = '/email';
    static readonly SEND_VERIFY_NEW_EMAIL = '/email/new';
    static readonly GET_2FA             = '/2fa';
    static readonly ADD_VERIFY_TOTP     = '/addverifytotp';
    static readonly NEW_RECOVERY_CODE   = '/recoverycode';
    static readonly API_V1_LOGIN        = '/api/v1/login';
    static readonly API_V1_PASSWORD     = '/api/v1/password';
    static readonly POLICY_ACCEPTANCE   = '/api/user/policy-acceptance';
    static readonly API_EXPORT_USERS_JSON = '/api/users/export/json';
    static readonly API_EXPORT_USERS_CSV  = '/api/users/export/csv';
    static readonly API_V1_OKTA_DOMAIN = '/api/v1/okta-domain';
    static readonly API_V1_OKTA_LOGIN = '/api/v1/okta-login';
    static readonly API_DISMISS_TOUR = '/api/v1/tour';
}
